import type {Search} from '../../types'
import {append} from 'ramda'
const initialState: Search = {
  params: {
    id: '',
    safeNo: '',
    regNo: '',
    vatNo: '',
    name: '',
    postalCode: '',
    city: '',
    street: '',
    countries: [],
    officeType: '',
    status: '',
    houseNumber: '',
    province: '',
    phoneNo: '',
    type: '',
  },
  companies: [],
  loader: false,
  totalSize: 0,
  error: null,
  paramsLoader: false,
  paramsError: null,
  criteriaSets: [],
  pageNo: 1,
  pageSize: 10,
  pageRange: 5,
  activeTab: [0],
  resTime: 0,
}

export default (state: Search = initialState, action): Search => {
  const {type, payload, data} = action
  switch (type) {
    case 'SEARCH_CRITERIA':
      return {
        ...state,
        paramsLoader: true,
        criteriaSets: [],
        companies: [],
        totalSize: 0,
        error: null,
      }
    case 'SEARCH_CRITERIA_SUCCESS':
      let availableLanguages = []
      if (payload.languages && payload.languages.length > 0) {
        availableLanguages = {
          language: {allowedValues: payload.languages},
        }
      }
      return {
        ...state,
        paramsLoader: false,
        params: {
          ...state.params,
          countries: payload.countries,
        },
        activeTab: [0],
        criteriaSets: append(availableLanguages, [...payload.criteriaSets]),
        paramsError: null,
      }
    case 'SEARCH_CRITERIA_FAILURE':
      return {
        ...state,
        paramsLoader: false,
        paramsError: payload.data,
        criteriaSets: [],
      }
    case 'SEARCH_DATA':
      return {
        ...state,
        companies: [],
        error: null,
        totalSize: 0,
        loader: true,
      }
    case 'SEARCH_DATA_SUCCESS':
      return {
        ...state,
        loader: false,
        companies: payload.companies,
        totalSize: payload.totalSize,
        resTime: payload.responseTime,
        error: null,
      }
    case 'SEARCH_DATA_FAILURE':
      return {
        ...state,
        loader: false,
        error: payload.data,
        companies: [],
        resTime: payload.responseTime,
        totalSize: 0,
      }
    case 'SEARCH_RESULT_PAGE_CHANGE':
      return {
        ...state,
        pageNo: data,
      }
    case 'ACTIVE_ACCORDION_ITEM':
      return {
        ...state,
        activeTab: data.activeItems,
      }
    case 'LOG_OUT':
      return initialState
    case 'RESET_SEARCH_PARAMS':
      return {
        ...state,
        params: {
          ...initialState.params,
          countries: [...state.params.countries],
        },
      }
    case 'CLEAR_SEARCH_CRITERIA':
      return {
        ...state,
        params: {
          ...initialState.params,
          countries: [...state.params.countries],
        },
        criteriaSets: [],
        paramsError: null,
        error: null,
        companies: [],
        resTime: 0,
        totalSize: 0,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/search/reducer.js